class BasicObject {
	id = null;
	name = '';
	active = true;

	constructor(data, validation = false) {
		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default BasicObject;
